import { createNetworkQuality, MeasurementMode, NetworkQualitySDK } from "@visonum/network-quality-sdk"
import { Subscription } from "rxjs";
import { NetworkQualitySdkPacer } from "./networkQualitySdkPacer";
import { API_KEY, baseUrl, NODE_ENV } from "./config"
import { isRunningInBrowser } from "./helper/ssr";
import * as R from "ramda";
import { logger } from "./helper/logger";
import packageInfo from '../package.json';
import { getUrlParamValue, getUrlQuery } from "./helper/utils";

let sdk: NetworkQualitySDK | null = null;

declare global {
    interface Window {
        sdk: NetworkQualitySDK;
    }
}

const parseMeasurementMode = (modeValue: string | null, defaultMode: MeasurementMode = MeasurementMode.Production) => {
    if (!R.isNil(modeValue) && modeValue in MeasurementMode) {
        return modeValue as MeasurementMode;
    }

    return defaultMode;
}

const getMeasurementModeFromUrl = (url: string | null) => parseMeasurementMode(getUrlParamValue(url, "mode"));

const getUsePacerFromUrl = (url: string | null) => !R.isNil(getUrlParamValue(url, "pacer"));

const getClientQueryStringFromUrl = (url: string | null) => getUrlQuery(url);

const createSdk = (url: string | null) => {
    const clientQueryString = getClientQueryStringFromUrl(url);
    if (!R.isNil(clientQueryString)) {
        logger.info(`Query String: "${clientQueryString}"`);
    }

    const mode = getMeasurementModeFromUrl(url);
    const usePacer = getUsePacerFromUrl(url);
    logger.info(`Measurement Mode: "${mode}", Use Pacer: "${usePacer}"'`);

    const sdk = usePacer ? new NetworkQualitySdkPacer(mode) : createNetworkQuality(mode, baseUrl, API_KEY, {
        clientBundleId: packageInfo.name,
        clientVersion: packageInfo.version,
        clientQueryString,
        logger,
    });

    if (NODE_ENV === "test" && isRunningInBrowser()) {
        window.sdk = sdk;
        logger.info("window.sdk has set.");
    }
    return sdk;
}

export function getSdk(): NetworkQualitySDK {
    if (sdk !== null) {
        return sdk;
    }

    const url = isRunningInBrowser() ? window.location.href : null;
    sdk = createSdk(url);

    return sdk;
}

export const currentSubscription = new class CurrentSubscription {
    private _subscription: Subscription | null = null
    public get subscription(): Subscription | null {
        return this._subscription
    }
    public set subscription(newValue: Subscription | null) {
        this._subscription?.unsubscribe()
        this._subscription = newValue
    }
}